import { type ActionFunctionArgs, json } from "@remix-run/node"
import { getValidatedFormData } from "remix-hook-form"
import { type z } from "zod"
import ContactForm, {
	type ContactFormSchema,
	contactFormResolver,
} from "#app/components/contact/contact-form"
import HandmadeQualityArts from "#app/components/logos/handmade-quality-arts"
import { APP_NAME } from "#app/utils/constants"
import { prisma } from "#app/utils/db.server"
import { generateMeta } from "#app/utils/meta.js"
import { redirectWithToast } from "#app/utils/toast.server"
import routes from "#routes"

export const meta = generateMeta({
	title: `Contacto - ${APP_NAME}`,
	description:
		"Contacta con Greta's Patchwork. Envíanos tus preguntas, comentarios o sugerencias. ¡Estamos aquí para ayudarte! Encuentra nuestros datos de contacto, formulario de contacto y horario de atención al cliente.",
})

export async function action({ request }: ActionFunctionArgs) {
	const {
		errors,
		data,
		receivedValues: defaultValues,
	} = await getValidatedFormData<z.infer<typeof ContactFormSchema>>(
		request,
		contactFormResolver,
	)

	if (errors) {
		// The keys "errors" and "defaultValue" are picked up automatically by useRemixForm
		return json({ errors, defaultValues })
	}

	await prisma.contactRequest.create({
		data,
	})

	// Do something with the data
	return redirectWithToast(routes.public.base.route(), {
		title: "Mensaje recibido",
		description:
			"Hemos recibido tu mensaje con éxito, nos podremos en contacto contigo lo antes posible.",
	})
}

// TODO: Send Email as confirmation to the user

export default function ContactRoute() {
	return (
		<main className="container h-full">
			<div className="my-[50px] flex items-start justify-between gap-x-24">
				<ContactForm />

				<HandmadeQualityArts className="hidden max-w-lg lg:block" />
			</div>
		</main>
	)
}
